import { usePropertyNumberUnits } from '../../../../../queries/PropertyFields/NonRentalCoreFields';
import { DropDownBox } from '@apply/components';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';

const MAX_UNITS = 35;

interface UnitsDropDownProps {
    propertyGuid: string;
    isReview?: boolean;
    /** Lowest option offered (defaults to 5). */
    minimum?: number;
    onValueChange?: (value: number | undefined) => void;
}

export const UnitsDropDown: React.FC<UnitsDropDownProps> = ({
    propertyGuid,
    isReview = false,
    minimum = 5,
    onValueChange,
}) => {
    const label = 'Units';
    const [numberUnits, set_numberUnits] = usePropertyNumberUnits(propertyGuid);

    // generate options minimum..35
    const numberUnitsValues = [
        { display: '', value: '' },
        ...Array.from({ length: MAX_UNITS - minimum + 1 }, (_, i) => i + minimum).map((count) => {
            return {
                display: count.toString(),
                value: count,
            };
        }),
    ];

    const handleNumberUnits = (value: number | undefined) => {
        set_numberUnits(value);
        onValueChange?.(value);
    };

    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={numberUnits}
                />
            ) : (
                <DropDownBox
                    id='numberNonRentalUnits'
                    value={numberUnits}
                    onChange={(value) => handleNumberUnits(value)}
                    label={label}
                    required={true}
                    dataSource={numberUnitsValues}
                    valueExpr='value'
                    displayExpr='display'
                />
            )}
        </>
    );
};
